import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withHotelCenterV2SiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { DetailListPageMenu } from '@bingads-webui-campaign-react/page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';

const DetailListPageMenuWithSiteMap = withHotelCenterV2SiteMap(DetailListPageMenu, processorSet.all);

const hotelCenterV2PageGroups = [[
  'property-center-overview',
  'property-center-feeds',
  'property-center-logos',
  'property-center-reports',
]];

export const Loader = (props) => {
  const { siteMap, updateAvailability, ...others } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    const available = !_.isEmpty(selectedParent);
    updateAvailability(available);
  });

  if (!props.isVisible) {
    return null;
  }

  return (
    <Scenario name="detail-list-page-memu">
      <Activity name="detail-list-page-memu">
        <DetailListPageMenuWithSiteMap pageGroups={hotelCenterV2PageGroups} noExpandGroups={[]} {...others} />
      </Activity>
    </Scenario>
  );
};

Loader.propTypes = {
  changeLayout: PropTypes.func,
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

Loader.defaultProps = {
  changeLayout: _.noop,
  updateAvailability: _.noop,
  isVisible: false,
};

export const HotelCenterV2PageMenuLoader = withHotelCenterV2SiteMap(
  React.memo(Loader),
  processorSet.all
);
